import { render, staticRenderFns } from "./SmartVoiceTokens.vue?vue&type=template&id=74ec5ad9&scoped=true"
import script from "./SmartVoiceTokens.vue?vue&type=script&lang=ts"
export * from "./SmartVoiceTokens.vue?vue&type=script&lang=ts"
import style0 from "./SmartVoiceTokens.vue?vue&type=style&index=0&id=74ec5ad9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ec5ad9",
  null
  
)

export default component.exports